<div [class]="single_message['report'] && single_message['post_id'] === 0  ? 'basic' : single_message['report'] ? 'report': ''">
    <section *ngIf='totalMessages > 0'>
        <h2 (click)="deleteMessage(single_message['id'])" class="close">×</h2>
        <h2 class='m_name'>{{single_message["from_shopper"]}}</h2>
        <h2 class='m_time'>{{single_message["created_at"] | date:'shortDate'}}</h2>
        <h2 class='m_time_desktop'>{{single_message["created_at"] | date:'longDate'}}</h2>
        <h1 (click)="messageShow()" #more>▼</h1>
    </section>

    <section *ngIf='totalMessages === 0' class='single'>
        <h2 class='m_title'>{{single_message["title"]}}</h2>
    </section>
    <section *ngIf='totalMessages > 0' class="message" #message>
        <h2>{{single_message["email"]}}</h2>
        <h2 class='m_title'>{{single_message["title"]}}</h2>
        <p>{{single_message["message"]}}</p>
    </section>
    <div *ngIf="deleted">
        <h1>Message Deleted!</h1>
    </div>
</div>
